<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'questionarioPerguntasCrud'"
          crudName="Questionário"
          newText="Nova pergunta"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="true"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  components: {
    BaseCrud,
  },
  data: function () {
    return {
      table: "questionarioPerguntasTable",
      pages: [],
      url: "",
      columns: ["id", "enunciado", "selecao", "ordem", "ativo", "actions"],
      tableData: ["id", "enunciado", "selecao", "ordem", "ativo"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "enunciado", "ordem"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          enunciado: "Pergunta",
          selecao: "Seleção",
          ordem: "Ordem",
          ativo: "Ativo",
          actions: "Ações",
        },
        texts: { filterBy: "Filtrar", defaultOption: "Selecione" },
        templates: {
          selecao: function (h, row) {
            const umaResposta = row.selecao === "unica";

            return h(
              "span",
              { class: umaResposta ? "badge badge-info" : "badge badge-primary" },
              umaResposta ? "Uma resposta" : "Várias respostas"
            );
          },
          ativo: function (h, row) {
            return h(
              "span",
              { class: row.ativo ? "badge badge-success" : "badge badge-secondary" },
              row.ativo ? "Sim" : "Não"
            );
          },
        },
        requestFunction: function (data) {
          let query = this.$parent.$parent.$parent.query(data.query);
          let requestData = {};
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.orderByAsc = "ordem";
          return this.$http
            .get(this.url + "?" + query, requestData)
            .catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
            );
        },
      },
      endPoint: "questionario_perguntas/",
      dataForm: {},
    };
  },
  methods: {
    query: function (query) {
      let columns = { id: "id", enunciado: "enunciado", ordem: "ordem" };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>
